import { createApiRef } from '@backstage/frontend-plugin-api';
import { CertInventoryApi } from '@internal/plugin-cert-inventory-common';

export const certInventoryApiRef = createApiRef<CertInventoryApi>({
  id: 'plugin.cert-inventory.service',
});
